import { useEffect } from 'react';
import { noop } from 'functions/noop';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';

export const useAppConfigurationChanged = () => {
  const { code: providerCode } = useProviderSpecificConfiguration();
  useEffect(() => {
    if (providerCode) {
      document.body.classList.add('provider-mode');
      return () => {
        document.body.classList.remove('provider-mode');
      };
    }
    return noop;
  }, [providerCode]);
};
